import React from "react";
import "./AddFeatures.scss";
import Grid from "@mui/material/Unstable_Grid2";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Link,
  Typography,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import SlidingPanel from "react-sliding-side-panel";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
  table_data: Array<{
    id: Number;
    sr_no: Number;
    category_name: string;
    feature_name: string;
    field_type: string;
    value_type: string;
    unit_type: string;
    description: string;
    action_btns: string;
    deleteable: boolean;
  }>;
}

const AddFeatures: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
  table_data,
}) => {
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [addCategoryStep, setAddCategoryStep] = React.useState<
    Array<{
      id: Number;
      sr_no: Number;
      category_name: string;
      feature_name: string;
      field_type: string;
      value_type: string;
      unit_type: string;
      description: string;
      action_btns: string;
      deleteable: boolean;
    }>
  >([
    {
      id: Math.random(),
      sr_no: 1,
      category_name: "",
      feature_name: "",
      field_type: "",
      value_type: "",
      unit_type: "",
      description: "",
      action_btns: "Edit",
      deleteable: false,
    },
  ]);

  const selectCategory_data = [
    { key: "Medical Cover", value: "Medical Cover" },
    { key: "Maternity Cover", value: "Maternity Cover" },
    { key: "Hospitalization Cover", value: "Hospitalization Cover" },
  ];
  const addFieldType_data = [
    { key: "Text Field", value: "Text Field" },
    { key: "Dropdown List", value: "Dropdown List" },
  ];
  const addValueType_data = [
    { key: "Numeric Only", value: "Numeric Only" },
    { key: "Alphanumeric", value: "Alphanumeric" },
    { key: "Text Only", value: "Text Only" },
  ];
  const unitType_data = [
    { key: "Days", value: "Days" },
    { key: "Days", value: "Days" },
    { key: "Days", value: "Days" },
  ];

  const updateMasterStateArray = (attrName: any, value: any) => {
    const array_data = [...addCategoryStep];
    if (attrName[1] === "category_name") {
      array_data[attrName[0]].category_name = value;
    } else if (attrName[1] === "feature_name") {
      array_data[attrName[0]].feature_name = value;
    } else if (attrName[1] === "field_type") {
      array_data[attrName[0]].field_type = value;
    } else if (attrName[1] === "value_type") {
      array_data[attrName[0]].value_type = value;
    } else if (attrName[1] === "unit_type") {
      array_data[attrName[0]].unit_type = value;
    } else if (attrName[1] === "description") {
      array_data[attrName[0]].description = value;
    }

    setAddCategoryStep(array_data);
  };

  const add_data = () => {
    let data: Array<{
      id: Number;
      sr_no: Number;
      category_name: string;
      feature_name: string;
      field_type: string;
      value_type: string;
      unit_type: string;
      description: string;
      action_btns: string;
      deleteable: boolean;
    }> = table_data;

    addCategoryStep.forEach((value) => {
      data = [
        ...data,
        {
          id: Math.random(),
          sr_no: value.sr_no,
          category_name: value.category_name,
          feature_name: value.feature_name,
          field_type: value.field_type,
          value_type: value.value_type,
          unit_type: value.unit_type,
          description: value.description,
          action_btns: value.action_btns,
          deleteable: value.deleteable,
        },
      ];
    });

    value_update("data_feature", data);
    value_update(attrName, false);
  };
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        // backdropClicked={() => value_update(attrName, false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 ml-3">Add New Feature</h4>
            </Grid>
            <Grid xs={2} textAlign="end">
              <GridCloseIcon
                onClick={() => {
                  value_update(attrName, false);
                }}
              />
            </Grid>
            <Grid xs={12} className="text-right">
              <Link
                className="greenBtn addfile"
                underline="none"
                onClick={() => {
                  setAddCategoryStep((addCategoryStep) => [
                    ...addCategoryStep,
                    {
                      id: Math.random(),
                      sr_no: 1,
                      category_name: "",
                      feature_name: "",
                      field_type: "",
                      value_type: "",
                      unit_type: "",
                      description: "",
                      action_btns: "Edit",
                      deleteable: true,
                    },
                  ]);
                }}
              >
                Add More
              </Link>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            {pageStatus !== 4 ? (
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <Typography>
                    {addCategoryStep.map((data, index) => (
                      <Grid container spacing={3} alignItems="center">
                        <Grid xs={9}>
                          <p className="labelTitle">{index + 1}. Feature</p>
                        </Grid>
                        {data.deleteable == false ? null : (
                          <Grid xs={3} className="text-right">
                            <Link
                              className="redBtn delete ml-0"
                              underline="none"
                              onClick={() => {
                                setAddCategoryStep((addCategoryStep) =>
                                  addCategoryStep.filter((_, i) => i !== index)
                                );
                              }}
                            >
                              Remove
                            </Link>
                          </Grid>
                        )}

                        <Grid xs={4}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Select Category"
                            value={data.category_name}
                            attrName={[index, "category_name"]}
                            value_update={updateMasterStateArray}
                            dropdown_data={selectCategory_data}
                          />
                        </Grid>
                        <Grid xs={4}>
                          <RKTextField
                            class_name="inputField"
                            title={"Feature Name"}
                            value={data.feature_name}
                            attrName={[index, "feature_name"]}
                            value_update={updateMasterStateArray}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={4}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Field Type"
                            value={data.field_type}
                            attrName={[index, "field_type"]}
                            value_update={updateMasterStateArray}
                            dropdown_data={addFieldType_data}
                          />
                        </Grid>
                        <Grid xs={4}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Value Type"
                            value={data.value_type}
                            attrName={[index, "value_type"]}
                            value_update={updateMasterStateArray}
                            dropdown_data={addValueType_data}
                          />
                        </Grid>
                        <Grid xs={8}>
                          <RKTextField
                            class_name="inputField"
                            title={"Description"}
                            value={data.description}
                            attrName={[index, "description"]}
                            value_update={updateMasterStateArray}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={4}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Unit Type"
                            value={data.unit_type}
                            attrName={[index, "unit_type"]}
                            value_update={updateMasterStateArray}
                            dropdown_data={unitType_data}
                          />
                        </Grid>
                      </Grid>
                    ))}
                  </Typography>
                </Grid>
              </Grid>
            ) : null}
            {pageStatus === 4 ? (
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Grid xs={12}>
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <p className="quote_success text-center">
                    New Client has been added successfully!
                  </p>
                </Grid>
              </Grid>
            ) : null}
          </div>
          {pageStatus !== 4 ? (
            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn mt-4">
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => {
                    setPageStatus(pageStatus + 1);
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </div>
      </SlidingPanel>
    </>
  );
};

export default AddFeatures;
